import React from 'react';

import Home from '../../layouts/Home/Home';
import { useAppSelector } from '../../shared/hooks';
import {
  HomeRoutes,
  ROUTES,
} from '../../types/routes';

interface Props {
  path: HomeRoutes;
  children: React.ReactNode;
}

const DynamicWrapper: React.FC<Props> = ({ path, children }) => {
  const {
    customRouter: { homeRoutes },
    hostMetadata: { isCommunityFeatureActive },
  } = useAppSelector((state) => state.app);

  const routes = isCommunityFeatureActive
    ? [
        ...homeRoutes,
        { name: ROUTES.COMMUNITY, config: { title: 'Community' } },
      ]
    : homeRoutes;

  const route = routes.find((r) => r.name === path);

  // memoize the home component
  if (route) {
    return <Home>{children}</Home>;
  }

  return children as JSX.Element;
};

export default React.memo(DynamicWrapper);
